module.exports = __webpack_public_path__ + "static/media/grey.5a746e55.ogg";